import { Controller } from '@hotwired/stimulus'

// Handles reaction toggling on public share pages
export default class extends Controller {
  static values = {
    token: String
  }

  async toggle(event) {
    const button = event.currentTarget
    const emoji = button.dataset.emoji

    if (!emoji) return

    try {
      button.classList.add('opacity-50')
      button.disabled = true

      const response = await fetch(`/api/v1/shares/${this.tokenValue}/reactions`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ emoji })
      })

      if (!response.ok) {
        throw new Error('Failed to toggle reaction')
      }

      const data = await response.json()
      this.updateReactionCounts(data.reaction_counts)

      // Add visual feedback
      if (data.added) {
        button.classList.add('bg-gray-100', 'border-gray-400')
      } else {
        button.classList.remove('bg-gray-100', 'border-gray-400')
      }
    } catch (error) {
      console.error('Error toggling reaction:', error)
    } finally {
      button.classList.remove('opacity-50')
      button.disabled = false
    }
  }

  updateReactionCounts(counts) {
    this.element.querySelectorAll('.reaction-btn').forEach((btn) => {
      const emoji = btn.dataset.emoji
      const countEl = btn.querySelector('.count')
      if (countEl && counts[emoji] !== undefined) {
        countEl.textContent = counts[emoji]
        btn.dataset.count = counts[emoji]
      }
    })
  }
}
